import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hrms6ae/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres6ae/labels')
  },
  getIndex (searchParams) {
    let sendParams = {}
    if (typeof searchParams !== 'undefined') {
      if (isMock) return generator(mocker.index())
      sendParams = {
        p_dtereq_st: (typeof searchParams.dtereqst.replace(/\//g, '') !== 'undefined' ? searchParams.dtereqst.replace(/\//g, '') : ''),
        p_dtereq_en: (typeof searchParams.dtereqen.replace(/\//g, '') !== 'undefined' ? searchParams.dtereqen.replace(/\//g, '') : ''),
        p_codcomp: (typeof searchParams.codcomp !== 'undefined' ? searchParams.codcomp : ''),
        p_codempid_query: ((typeof searchParams.codempid !== 'undefined' && searchParams.codempid !== '') ? searchParams.codempid : '%')
      }
    } else {
      sendParams = {
        p_codempid_query: '%'
      }
    }
    return instance().get(endpoint + '/hres6ae/index', { params: sendParams })
  },
  getDetail (searchParams) {
    let sendParams = {
      p_dtereq: searchParams.dtereq,
      p_numseq: searchParams.numseq,
      p_dtework: searchParams.dtework,
      p_dteworkstrt: searchParams.dtework,
      p_dteworkend: searchParams.dtework,
      p_codempid_query: searchParams.codempid_query
    }
    if (isMock) return generator(mocker.detail())
    const params = sendParams.p_dtereq.replace(/\//g, '') + '/' + sendParams.p_numseq + '/' + sendParams.p_dtework.replace(/\//g, '') + '/' + sendParams.p_codempid_query
    return instance().get(endpoint + '/hres6ae/update/' + params)
  },
  getDetailSearch (searchDetail) {
    if (!searchDetail.codempid) {
      return generator({
        table: {
          total: 0,
          rows: []
        },
        popup: {
          detail: {},
          table: {
            total: 0,
            rows: []
          }
        }
      })
    }
    let sendParams = {
      p_dteworkstrt: searchDetail.dteworkst,
      p_dteworkend: searchDetail.dteworken,
      p_codempid_query: searchDetail.codempid
    }
    if (isMock) return generator(mocker.detailSearch())
    const params = sendParams.p_dteworkstrt.replace(/\//g, '') + '/' + sendParams.p_dteworkend.replace(/\//g, '') + '/' + sendParams.p_codempid_query
    return instance().get(endpoint + '/hres6ae/updateSearch/' + params)
  },
  postSave (dataRowsHasFlg) {
    for (let dataRow of dataRowsHasFlg) {
      if (typeof dataRow.p_codempid_query !== 'undefined') {
        dataRow.codempid_query = dataRow.p_codempid_query
      }
    }
    let sendParams = {
      param_json: JSON.stringify(dataRowsHasFlg)
    }
    if (isMock) return generator(mocker.save())

    return instance().post(endpoint + '/hres6ae/updateAll', sendParams)
  },
  postCancel (cancelParams) {
    if (isMock) return generator(mocker.cancel())
    return instance().post(endpoint + '/hres6ae/cancel', cancelParams)
  },
  getDropdowns () {
    if (isMock) return generator(mocker.dropdowns())
    return instance().get(endpoint + '/hres6ae/dropdowns')
  }
}



// WEBPACK FOOTER //
// ./src/api/hrms6ae/index.js